import React, { useState, useEffect } from "react";
import { useNavigate, useLocation,useParams } from "react-router-dom";
import { TbChevronDown, TbChevronUp, TbPlus, TbRefresh,TbMessageCircle } from "react-icons/tb";
import AddTimeline from "./TimelineEntryModel.js";

const TaskDetailsModel = () => {
  const { taskGroupId } = useParams();
  const navigate = useNavigate();
  const [taskFullDetails, setTaskFullDetails] = useState([]);
  const [taskLogDetails, setTaskLogDetails] = useState([]);
  const [itemToAdd, setItemToAdd] = useState(null);
  const [addTimelineModel, setAddTimelineModel] = useState(false);
  const Auth = localStorage.getItem("authToken");
  const [loading,setLoading] = useState(true);
  const location = useLocation();
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [selectedTaskId, setSelectedTaskId] = useState(null);




  useEffect(() => {
    if (!Auth) {
      navigate("/login", { state: { from: location }, replace: true });
      return;
    }
    if (!taskGroupId) return;
    fetchTaskDetailsWithLogs();
  }, [Auth, taskGroupId, navigate, location]);
useEffect(() => {
  if (taskFullDetails?.team_members?.length > 0) {
    setSelectedMemberId(taskFullDetails.team_members[0].user_id);
    setSelectedTaskId(taskFullDetails.team_members[0].task_id);
  }
}, [taskFullDetails]);
  const fetchTaskDetailsWithLogs = async () => {
    try {
      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/task-details/group/${taskGroupId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch task details");
      const result = await response.json();
      setTaskFullDetails(result || []);
      setTaskLogDetails(result.team_members || []);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching task details:", err);
    }
  };
  const handleAddTimelineClick = (id) => {
    setItemToAdd(id);
    setAddTimelineModel(true);
  };

  const cancelTimelineUser = () => {
    setAddTimelineModel(false);
    setItemToAdd(null);
  };
  const confirmAddTimeline = async (formData) => {
      try {
        
        const response = await fetch("https://backend.sanchalansetu.com/api/v1/task-log/addbyadmin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`
          },
          body: JSON.stringify(formData),  
        });
        const errorText = await response.json();
        if (!response.ok) {

          throw new Error(`Failed to save user: ${errorText}`);

        }
      } catch (error) {
        console.error("Error saving user:", error);
      }
      fetchTaskDetailsWithLogs();
      setAddTimelineModel(false);
      setItemToAdd(null);
    };
  const handleOnClose = () => {

      navigate(`/task-details`);
    };

  return (
    <div className="Task-Details-Container">
      <div className="p-4" role="dialog" aria-modal="true">
        <div className="bg-white rounded-xl shadow-lg w-full w-full p-6 overflow-y-auto ">
          {loading ? ( <p>Loading</p> ) : (
            <>
      
              <div className="bg-gradient-to-r from-teal-400 to-cyan-500 rounded-2xl p-4 text-white shadow-md mb-6">
                <div className="flex items-center gap-4">
                  <button
                    className="bg-white/20 px-3 py-1 rounded-full hover:bg-white/30"
                    onClick={handleOnClose}
                  >
                    ←
                  </button>
                  <div className="text-left">
                    <h1 className="text-2xl font-semibold">{taskFullDetails.title || "N/A"}</h1>
                    <p className="text-sm opacity-90">
                      Assigned By:{" "}
                      <span className="font-medium">{taskFullDetails.from_user_name}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Task Info */}
              <div className="space-y-4">
                <InfoCreatedAt label="Created At" value="2025-10-16 15:02:14" />
                <TimeLeft
                  label="Time Left"
                  value={taskFullDetails.created_at}
                  subValue={taskFullDetails.deadline_time}
                />
                <InfoCard label="Task Description" value={taskFullDetails.description ||"N/A"} />
                <MemberInfoCard label="Team Members" value={taskFullDetails.team_members ||"N/A"} />
                <ShowImages label="Attachments" value={taskFullDetails.file_links}/>
                <InfoLink label="No link provided" value={taskFullDetails.link_if_any} />
              </div>

    
              <div className="mt-6 bg-transparent rounded-2xl shadow p-4">
                {/* Member Tabs */}
                <div className="flex flex-wrap gap-3 mb-4">
                  {taskFullDetails?.team_members?.map((member) => (
                    <div key={member.user_id}
                      onClick={() => { setSelectedMemberId(member.user_id); setSelectedTaskId(member.task_id); }}
                      className={`cursor-pointer flex items-center gap-2 px-3 py-2 rounded-lg border transition-all duration-300 ${
                        selectedMemberId === member.user_id
                          ? "bg-blue-100 border-blue-500 shadow-md"
                          : "bg-gray-50 border-gray-200 hover:bg-gray-100"
                      }`}
                    >
                      <img
                        src={member.avatar}
                        alt={member.user_name}
                        className="w-8 h-8 rounded-full border"
                      />
                      <span className="text-sm font-medium text-gray-700">
                        {member.user_name}
                      </span>
                    </div>
                  ))}
                </div>

  
                <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-2 rounded-xl shadow-sm flex gap-4 justify-between">
                  <div className="text-sm font-semibold text-gray-700">
                    Task Timeline
                  </div>
                  <div className="flex space-x-3">
                    <button
                      className="p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                      onClick={fetchTaskDetailsWithLogs}
                    >
                      <TbRefresh className="text-xl" />
                    </button>
                    {selectedMemberId && (
                      <button
                        className={`p-2 rounded-full text-white ${
                          taskFullDetails.status === 1
                            ? "bg-gray-400 "
                            : "bg-green-500 hover:bg-green-600"
                        }`}
                        /* disabled={taskFullDetails.status === 1} */
                        onClick={() => handleAddTimelineClick(selectedTaskId)}
                      >
                        <TbPlus className="text-xl" />
                      </button>
                    )}
                  </div>
                </div>

                <br />

  
                <div className="pl-4 space-y-6 max-h-80 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-orange-400 scrollbar-track-orange-100">
                  {taskFullDetails?.team_members
                    ?.find((m) => m.user_id === selectedMemberId)
                    ?.task_logs?.map((log, index) => (
                      <TimelineItem
                        key={log.log_id || index}
                        title={log.description}
                        action={log.action_type}
                        assign={log.logged_by_name}
                        date={log.log_created_at}
                      />
                    )) || (
                      <p className="text-gray-500 text-sm">No logs available.</p>
                    )}
                </div>
              </div>
              {addTimelineModel && (
                <AddTimeline
                  taskId={itemToAdd}
                  onClose={cancelTimelineUser}
                  onSubmit={(formData) => confirmAddTimeline(formData)}
                />
              )}
            </>
          )}
          <div className="mt-6 flex justify-end">
            <button
              onClick={handleOnClose}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskDetailsModel;

// Utility for date formatting
const formatDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  return isNaN(date.getTime()) ? value : date.toLocaleString();
};

// InfoCard Component
function InfoCard({ label, value, subValue }) {
  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm">
      <p className="text-sm font-semibold text-gray-700">{label}</p>
      <p className="text-xs text-gray-800">{value}</p>
      {subValue && <p className="text-xs text-gray-600 mt-1">Reporting Time : {subValue}</p>}
    </div>
  );
}
function MemberInfoCard({ label, value }) {

  const displayValue = Array.isArray(value)
    ? value.map(member => member.user_name).join(', ')
    : value;

  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm">
      <p className="text-sm font-semibold text-gray-700">{label}</p>
      <p className="text-xs text-gray-800">{displayValue || 'None'}</p>
    </div>
  );
}

function InfoLink({ label, value }) {
  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm">
      <p className="text-sm font-semibold text-gray-700">{label}</p>
      
      {value ? (
        <a href={value} className="text-xs text-blue-600 underline">
          {value}
        </a>
      ) : (
        <p className="text-xs text-gray-800">N/A</p>
      )}
    </div>
  );
}
function ShowImages({ label, value }) {
  const files = value ? value.split(',') : [];

  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm">
      <p className="text-sm font-semibold text-gray-700 mb-2">{label}</p>

      {files.length > 0 ? (
        <div className="grid grid-cols-2 gap-2">
          {files.map((fileUrl, index) => {
            const trimmedUrl = fileUrl.trim(); // remove extra spaces
            const isPdf = trimmedUrl.toLowerCase().endsWith(".pdf");

            /* if (isPdf) { */
              return (
                <a
                  key={index}
                  href={trimmedUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline text-sm block p-2 bg-white rounded shadow text-center"
                >
                  File {index + 1}
                </a>
              );
            /* } */

            /* return (
              <img
                key={index}
                src={trimmedUrl}
                alt={`file-${index}`}
                className="w-full h-[200px] object-cover rounded"
              />
            ); */
          })}
        </div>
      ) : (
        <p className="text-xs text-gray-800">N/A</p>
      )}
    </div>
  );
}



function InfoCreatedAt({ label, value, subValue }) {
  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm flex gap-4 item-center ">
      <p className="text-sm font-semibold text-gray-700">{label}</p>
      <p className="text-sm font-semibold text-gray-700">{value}</p>
    </div>
  );
}

// TimelineItem Component
function TimelineItem({ title,action, date, assign }) {
  const [openDetails, setOpenDetails] = useState(false);
  const formattedAction = action
    ? action
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
  return (
    <div className="flex items-start space-x-3">
      <div className="w-full border-2 rounded-lg p-3 transition-all duration-300" onClick={() => setOpenDetails(!openDetails)}>
        <div className="flex justify-between items-center">
          
          <div onClick={() => setOpenDetails(!openDetails)} className="cursor-pointer w-full">
            <p className="text-sm text-gray-800">{formattedAction}: {title}</p>
            <p className="text-xs text-gray-500 mt-1">{date}</p>
          </div>

          
          <div
            className="cursor-pointer text-lg font-bold text-gray-600"
            onClick={() => setOpenDetails(!openDetails)}
          >
            {openDetails ? <TbChevronUp /> : <TbChevronDown />}
          </div>
        </div>

        
        {openDetails && (
          <div  className="cursor-pointer w-full border-2 p-2 bg-gray-200 mt-2 rounded-lg">
            <p className="text-xs text-gray-800">Description: {title}</p>
            <p className="text-xs text-gray-800 mt-1">By: {assign}</p>
          </div>
        )}
      </div>
    </div>
  );
}



function TimeLeft({ label, value, subValue }) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!subValue) return;

    const updateTime = () => {
      const now = new Date();
      const end = new Date(subValue);
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft("Time over");
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(`${days} days : ${hours} : ${minutes} : ${seconds}`);
    };

    updateTime(); // run once immediately
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [subValue]);

  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 p-3 rounded-xl shadow-sm">
      <p className="text-sm font-semibold text-gray-700">{label} : {timeLeft}</p>

      {/* Show time left if subValue exists */}
      
          <p className="text-xs text-gray-600 mt-1">
            Reporting Time : {new Date(subValue).toLocaleString()}
          </p>
        
    </div>
  );
}


